import AutoplayController from "~/lib/autoplay_controller"
import { money, tween } from "~/lib/motion"

// The cursor steps up through the quantity tiers while the total updates
export default class extends AutoplayController {
  static targets = ["tier", "button", "buttonLabel", "total"]

  reset() {
    this.select(this.tierTargets[0])
    this.totalTarget.textContent = money(this.price(this.tierTargets[0]))
    this.buttonTarget.classList.remove("is-done")
    this.buttonLabelTarget.textContent = "Add to cart · "
  }

  async play(wait) {
    let total = this.price(this.tierTargets[0])
    for (const tier of this.tierTargets.slice(1)) {
      await wait(500)
      await this.click(tier, wait)
      this.select(tier)
      tween(this.totalTarget, total, this.price(tier))
      total = this.price(tier)
    }
    await wait(600)
    await this.click(this.buttonTarget, wait)
    this.buttonTarget.classList.add("is-done")
    this.buttonLabelTarget.textContent = "✓ Added · "
  }

  select(tier) {
    this.tierTargets.forEach((t) => t.classList.toggle("is-selected", t === tier))
  }

  price(tier) {
    return Number(tier.dataset.price)
  }
}
